import { render, staticRenderFns } from "./TaxDetails.vue?vue&type=template&id=ea7c40c0&scoped=true"
import script from "./TaxDetails.vue?vue&type=script&lang=js"
export * from "./TaxDetails.vue?vue&type=script&lang=js"
import style0 from "./TaxDetails.vue?vue&type=style&index=0&id=ea7c40c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7c40c0",
  null
  
)

export default component.exports